import React, { useState } from 'react';
import Form from '../common/Form';
import FormField from '../common/FormField';
import { StateDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface StateFormProps {
  initialValues: StateDTO;
  countryId: string;
  onSubmit: (data: StateDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const validationRules: ValidationRules = {
  name: [{ required: true, message: 'Name is required' }],
};

const StateForm: React.FC<StateFormProps> = ({
  initialValues,
  countryId,
  onSubmit,
  onCancel,
  isLoading = false,
}) => {
  const [formData, setFormData] = useState<StateDTO>({
    ...initialValues,
    countryId,
  });

  const { errors, validate } = useFormValidation<StateDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit({ ...formData, countryId });
    }
  };

  return (
    <Form sections={[]} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading} hideHeader>
      <FormField
        id="name"
        label="Name"
        type="text"
        value={formData.name || ''}
        onChange={(e) => handleChange(e, setFormData)}
        placeholder="Enter Name"
        required
        error={errors.name}
      />
      <FormField
        id="code"
        label="Code"
        type="text"
        value={formData.code || ''}
        onChange={(e) => handleChange(e, setFormData)}
        placeholder="Enter Code"
        error={errors.code}
      />
    </Form>
  );
};

export default StateForm;
